<template>
  <section v-if="user.information && loaded">
    <div v-if="!meeting_enabled">
      <div class="center-information">
        <div class="center-information-content">
          <i class="fa-light fa-2x fa-video-slash"></i>
          <br /><br />
          {{ $t("NO_MEETING_SERVICE") }}
        </div>
      </div>
    </div>


  <div
      id="wrapper"
      v-bind:class="{ showFolders: showFolders }"
      :key="$route.fullPath"
    >
      <div v-if="user.delegatedboxes && 1 == 0" id="inbox-sidebar" class="h-100">
        <i
          class="fal fa-chevron-right nav-icon clickable"
          v-show="!showFolders"
          @click="showFolders = true"
        ></i>
        <i
          class="fal fa-chevron-left nav-icon clickable"
          v-show="showFolders"
          @click="showFolders = false"
        ></i>

        
        <MeetingsMenu
          :functionbox_uuid="functionbox_uuid"
          :user_uuid="user_uuid"
          :showFolders="showFolders"
          :is-mobile="device.isMobile"
          @closeFolders="closeFolders"          
        ></MeetingsMenu>

  
      </div>
      <div id="inbox-content">
<div  class="w-100">



    <div v-show="message_uuid == ''" v-if="meeting_enabled">


<div class="mb-2 ml-2">
              <span
                ><img
                  class="icon"
                  src="/img/message_type/message.png"
                  :alt="$t('MESSAGES.TYPE.message')"
                />
                {{ boxInformation.name }}, {{ boxInformation.email }}
                <span v-if="boxInformation.fax || boxInformation.sdk">, </span>
              </span>
              <span v-if="boxInformation.fax"
                ><img
                  class="icon"
                  src="/img/message_type/fax-message.png"
                  :alt="$t('MESSAGES.TYPE.fax-message')"
                />
                {{ boxInformation.fax }}
                <span v-if="boxInformation.sdk">, </span>
              </span>
              <span v-if="boxInformation.sdk"
                ><img
                  class="icon"
                  src="/img/message_type/sdk-message.png?id=2"
                  :alt="$t('MESSAGES.TYPE.sdk-message')"
                />
                {{ boxInformation.sdk }}</span
              >
            </div>


      <b-form inline class="mt-2">
        <AddressBook
          :user_uuid="user_uuid"
          functionbox_uuid=""
          v-slot:activator="{ onClick }"
        >
          <b-button
            @click="onClick"
            class="no-border"
            v-b-tooltip.hover
            :title="$t('ADDRESSBOOK.TITLE')"
          >
            <i class="fal fa-address-book"></i
          ></b-button>
        </AddressBook>

        <b-button @click="refreshList" class="no-border"
          ><i class="fal fa-sync"></i
        ></b-button>

        <AddMeeting
          @Close="CloseAddMeeting"
          :key="addMeetingKey"
          @Changed="Changed"
          :draftInformation="draftInformation"
        ></AddMeeting>

        <label class="sr-only" for="search-meetings">{{ $t("SEARCH") }}</label>
        <b-form-input
          trim
          id="search-meetings"
          class="ml-2 i-100 hidden-mobile searchText ml-2"
          v-model="searchText"
          debounce="500"
          :placeholder="$t('SEARCH')"
          @keydown.enter.prevent
        ></b-form-input>
        <label class="sr-only" for="list-limit-meetings">{{
          $t("LIMIT")
        }}</label>
        <b-form-select
          id="list-limit-meetings"
          name="meetings_limit"
          v-model="limit"
          class="limit hidden-mobile"
        >
          <b-form-select-option value="10">10</b-form-select-option>
          <b-form-select-option value="25">25</b-form-select-option>
          <b-form-select-option value="45">45</b-form-select-option>
          <b-form-select-option value="100">100</b-form-select-option>
        </b-form-select>

        <div class="hidden-not-mobile w-100 mt-2">
          <b-form inline>
            <label class="sr-only" for="search-meetings-mobile">{{
              $t("SEARCH")
            }}</label>
            <b-form-input
              trim
              id="search-meetings-mobile"
              class="ml-2 i-100 searchText"
              v-model="searchText"
              :placeholder="$t('SEARCH')"
              @keydown.enter.prevent
            ></b-form-input>
            <label class="sr-only" for="inline-form-input-limit-mobile">{{
              $t("LIMIT")
            }}</label>
            <b-form-select
              id="inline-form-input-limit-mobile"
              name="meetings_limit_mobile"
              v-model="limit"
              class="limit"
            >
              <b-form-select-option value="10">10</b-form-select-option>
              <b-form-select-option value="25">25</b-form-select-option>
              <b-form-select-option value="45">45</b-form-select-option>
              <b-form-select-option value="100">100</b-form-select-option>
            </b-form-select>
          </b-form>
        </div>
      </b-form>

      <b-nav tabs>
        <b-nav-item
          :to="{
            name: 'Meetings.Calendar',
            query: { user_uuid: user_uuid },
            params: { searchText: searchText },
          }"
          exact
          >{{ $t("MEETINGS.CALENDAR") }}</b-nav-item
        >

        <b-nav-item
          :to="{
            name: 'Meetings.Drafts',
            query: { user_uuid: user_uuid },
            params: { searchText: searchText },
          }"
          exact
          >{{ $t("MESSAGES.DRAFTS") }}</b-nav-item
        >
      </b-nav>

      <router-view
        :refresh="'router_Meetings' + keyIndex"
        :searchText.sync="searchText"
        @changeUpdateMessageUuid="changeUpdateMessageUuid"
        :user_uuid="user_uuid"
        :update_message_uuid="update_message_uuid"
        @viewingMessage="viewingMessage"
        @draftMeeting="DraftMeeting"
        :limit.sync="limit"
      ></router-view>
      
    </div>
    <div v-if="message_uuid != ''">
      <Message
        :message_uuid="message_uuid"
        :user_uuid="user_uuid"
        :startMeeting="startMeeting"
        :endMeeting="endMeeting"
        functionbox_uuid=""
        show-close-btn
        @closeMessage="closeMessage"
      ></Message>
    </div>
      </div></div>
    </div>
  </section>
</template>
<script>
import mobileDetect from "mobile-device-detect";
import MeetingsMenu from "@/components/Layout/MeetingsMenu";
import AddressBook from "@/components/AddressBook/Page";
import Message from "@/components/View/Message";
import AddMeeting from "@/components/Compose/AddMeeting";
export default {
  components: { Message, AddMeeting, AddressBook, MeetingsMenu },
  props: ["functionbox_uuid", "email", "view_message_uuid", "user_uuid"],
  data() {
    return {
      device: mobileDetect,
      showFolders: true,
      startMeeting: null,
      endMeeting: null,
      draftInformation: null,
      update_message_uuid: "",
      viewMessage: false,
      searchText: "",
      limit: 45,
      information: null,
      message_uuid: this.view_message_uuid,
      keyIndex: 0,
      meeting_enabled: true,
      addMeetingKeyIndex: 0,
      loaded: false,
      selectedTab: "calendar",
    };
  },
  methods: {    
    closeFolders() {
      if (this.device.isMobile) {
        this.showFolders = false;
      }
      this.closeMessage();
    },
    DraftMeeting(draftInformation) {
      this.draftInformation = draftInformation;      
      this.message_uuid = "";
      this.update_message_uuid = "";
      this.startMeeting = null;
      this.endMeeting = null;
    },
    async checkEnabled() {
      let self = this;
      await this.$http
        .get(this.user.hostname + "/meeting/enabled")
        .then(function (result) {
          self.meeting_enabled = result.data;
          self.loaded = true;
        })
        .catch(function () {
          self.meeting_enabled = false;
          self.loaded = true;
        });
    },
    changedView(view) {
      this.currentView = view;
    },
    changeUpdateMessageUuid(update_message_uuid) {
      this.update_message_uuid = update_message_uuid;
      this.message_uuid = "";
      this.draftInformation = {        
        messageUuid: '',
        location: ''
      };
      this.startMeeting = null;
      this.endMeeting = null;
    },
    refreshList() {      
      this.keyIndex++;
    },
    Changed() {      
      this.$router.push({ name: "Meetings.Calendar" }).catch(() => {});
      this.draftInformation = null;
      this.refreshList();
    },
    CloseAddMeeting(){
      this.draftInformation = null;
      this.refreshList();
    },
    viewingMessage(item) {
      this.message_uuid = item.MessageUuid;
      this.draftInformation = null;
      this.update_message_uuid = "";
      if(item.Recurrence != null)
      {
        this.startMeeting = item.StartTime;
        this.endMeeting = item.EndTime;
      }else{
        this.startMeeting = null;
        this.endMeeting = null;
      }
    },
    closeMessage() {
      this.update_message_uuid = this.message_uuid;
      this.message_uuid = "";
      this.draftInformation = null;
      this.refreshList();
      this.startMeeting = null;
      this.endMeeting = null;
    },
    selectTab(tab) {
      this.selectedTab = tab;
      this.refreshList();
    },
  },
  computed: {
    boxInformation() {
      let boxInformationObj = {
        name: "",
        email: "",
        sdk: "",
        fax: "",
      };
      if (this.user_uuid == "" && this.functionbox_uuid == "") {
        boxInformationObj.name = this.user.information.name;
        boxInformationObj.email = this.user.information.email;
      } else {
        if (this.user_uuid != "") {
          for (let ix = 0; ix < this.user.delegatedboxes.items.length; ix++) {
            if (
              this.user.delegatedboxes.items[ix].user_uuid == this.user_uuid
            ) {
              boxInformationObj.name = this.user.delegatedboxes.items[ix].name;
              boxInformationObj.email =
                this.user.delegatedboxes.items[ix].email;
            }
          }
        } else {
          if (this.functionbox_uuid != "") {
            for (let ix = 0; ix < this.user.functionboxes.items.length; ix++) {
              if (
                this.user.functionboxes.items[ix].functionbox_uuid ==
                this.functionbox_uuid
              ) {
                //console.log(this.user.functionboxes.items[ix]);
                boxInformationObj.name = this.user.functionboxes.items[ix].name;
                boxInformationObj.email =
                  this.user.functionboxes.items[ix].email;
                if (
                  this.user.functionboxes.items[ix].sdk_identifier != undefined
                ) {
                  boxInformationObj.sdk =
                    this.user.functionboxes.items[ix].sdk_identifier;
                }
                if (
                  this.user.functionboxes.items[ix].fax_identifier != undefined
                ) {
                  boxInformationObj.fax =
                    this.user.functionboxes.items[ix].fax_identifier;
                }
              }
            }
          }
        }
      }
      return boxInformationObj;
    },
    listMeetingKey() {
      return "listMeetingKey_" + this.keyIndex;
    },
    addMeetingKey() {
      return "addMeetingKey_" + this.keyIndex;
    },
  },
  mounted() {
    this.checkEnabled();
  },
};
</script>
<style></style>
